<template lang="html">
  <div class="page-wrapper">
    <div class="container">
      <div class="coach-detail-info">
        <BaseLoading  :spinning="coachLoading" size="large">
          <div class="heading">
            <h2 class="form-title">
              {{ coach.name }}
            </h2>
            <p class="text-italics text-capitalize position-info">
              {{ coach.jobDescription }}
            </p>
            <a-button
              v-if="canReport && coach.lastLogin"
              type="primary"
              @click="handleCoachReport"
              class="next-button save-button"
              >Report This Coach</a-button
            >
          </div>
          <div class="coach-details-container">
            <a-row :gutter="32">
              <a-col :sm="24" :md="10">
                <div class="img-wrap">
                  <img
                    class="coach-image-wrapper"
                    :src="generateImageUrl(coach.profileImage)"
                  />
                </div>
              </a-col>
              <a-col :sm="24" :md="14">
                <div class="coach-description-wrapper">
                  <div class="coach-description-header">
                    <p class="title">Title :</p>
                    <p class="position">{{ coach.position }}</p>
                  </div>
                  <div class="coach-description">
                    <p class="w-space-preline">{{ coach.description }}</p>
                  </div>
                </div>
              </a-col>
            </a-row>
          </div>
        </BaseLoading>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { Base } from "@/models";
const COACH_STORE_KEY = "coachStore";

export default {
  computed: {
    ...mapGetters({
      coach: `${COACH_STORE_KEY}/coach`,
      coachLoading: `${COACH_STORE_KEY}/coachLoading`
    }),
    coachId() {
      return this.$route.params["id"];
    },
    canReport() {
      return this.exceptBasicPlayer() && Base.userType() === "athlete";
    }
  },
  mounted() {
    this.dispatcher();
  },
  methods: {
    dispatcher() {
      this.$store.dispatch(`${COACH_STORE_KEY}/getCoach`, {
        id: this.coachId
      });
    },
    handleCoachReport() {
      let route = `/${Base.profileId()}/complain`;
      sessionStorage["coach-id"] = this.coach.id;
      sessionStorage["coach-type"] = this.coach.uniqueSlug;
      sessionStorage["coach-name"] = this.coach.name;
      this.$router.push({
        path: route
      });
    }
  }
};
</script>

<style lang="scss">
.coach-detail-info {
  .heading {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    margin-bottom: 60px;
    .form-title {
      width: fit-content;
      text-transform: uppercase;
      font-size: 18px;
      color: #4f5152;
      position: relative;
      padding-left: 10px;
      &::before {
        content: "";
        position: absolute;
        left: 0;
        top: 0;
        width: 4px;
        height: 100%;
        background: #d23129;
      }
    }
    .position-info {
      font-weight: 500;
      text-align: center;
      margin: 10px 0 20px !important;
      &.club-coach {
        margin-bottom: 0 !important;
      }
    }
  }
  .coach-description-wrapper {
    .coach-description-header {
      display: flex;
      justify-content: flex-start;
      background: #f1f1f1;
      border-top: 1px solid #cacaca;
      padding: 8px 15px;
      margin-bottom: 20px;
      .title {
        font-weight: 600;
        font-size: 14px;
        color: #505050;
        margin: 0 !important;
        padding-right: 20px;
      }
      .position {
        font-size: 14px;
        font-weight: 500;
        color: #2f2f2f;
        margin: 0 !important;
      }
    }
    .coach-description {
      p {
        font-weight: 400;
        white-space: pre-line;
        font-size: 14px;
        line-height: 22px;
        color: #616161;
        margin: 0 !important;
        padding-right: 10px;
      }
    }
  }
}

@media only screen and (max-width: 767px) {
  .coach-detail-info {
    .heading {
      margin-bottom: 40px;
    }
    .coach-details-container {
      padding: 0 20px;
      .img-wrap {
        width: 300px;
        margin: 0 auto 30px;
      }
      .coach-description-wrapper {
        text-align: center;
        .coach-description-header {
          justify-content: center;
        }
      }
    }
  }
}

@media only screen and (max-width: 575px) {
  .coach-detail-info {
    .coach-details-container {
      .img-wrap {
        width: 100%;
      }
    }
  }
}
</style>
